import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  addOfficeLocation,
  updateOfficeLocation,
} from '../../actions/userActions/officelocationAction'
import { getCities } from '../../actions/userActions/cityAction'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CancelButton from '../subComponents/buttons/CustomCancelButton'
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import SaveButton from '../subComponents/buttons/SaveButton'
import { CircularProgress, IconButton } from '@mui/material'
import HrComponent from '../reuse_components/HrComponent'
import BodyLargeMedium from '../designSystem/BodyLargeMedium'
import TextField from '../designSystem/TextField'
import SingleSelect from '../designSystem/SingleSelect'
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium'

import officeLocationIcon from "../../assets/images/Icon=Office Locations.svg";

import closeModal from "../../assets/images/closeModal.svg";
import { validateFields } from '../../utils/Validations'
import { Check, X, Plus } from 'lucide-react'
import BodyMediumMedium from '../designSystem/BodyMediumMedium'

import AddNewDrawer from '../addNew/AddNewDrawer'
import cityicon from "../../assets/images/cityIcon (2).svg";
import AddNewForm from '../addNew/AddNewForm'
import { t } from '../../locales/translate'

function AddOfficeLocations({ onClose, editData, onSave }) {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const initialValues = {
    address: '',
    contact1: '',
    contact2: '',
    email: '',
    fax: '',
    extensions: '',
    cityId: '',
    cityName: '',
    isHeadOffice: false,
  }
  const [isSubmit, setIsSubmit] = useState(false);
   const [drawerOpen, setDrawerOpen] = useState(false);
const [drawerItem , setDrawerItem] = useState(null);
  const [cityFilters, setCityFilters] = useState({
    textSearch: '',
    countryId: '1',
  })
  const cityBody = {
    filter: cityFilters,
    pageNumber: -1,
    pageSize: 0,
  }
  const [loading, setLoading] = useState(true);
  const [formValues, setFormValues] = useState(initialValues)
  const [formErrors, setFormErrors] = useState({})
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getCities(cityBody));
        if (editData) {
          setFormValues((prevValues) => ({
            ...prevValues,
            address: editData.address,
            contact1: editData.contact1,
            contact2: editData.contact2,
            email: editData.email,
            fax: editData.fax,
            extensions: editData.extensions,
            isHeadOffice: editData.isHeadOffice === "Yes" ? true : false,
            cityId: editData.cityId,
            id: editData.id,
            cityName: editData.cityName,
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [editData]);

  const getOptions = () => {

    return (
      allCities !== "isLoading" &&
      allCities.length !== 0 &&
      allCities?.result.length !== 0 &&
      allCities?.result
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((city) => ({
          value: city.id,
          label: city.name
        }))
    ) || [];
  };

  const handlecheckChange = (e) => {
    const { name, type, checked, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: type === "checkbox" ? checked : value, // Directly assign `checked`
    });
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      location.officeLocation
        ? dispatch(updateOfficeLocation(formValues))
        : dispatch(addOfficeLocation(formValues));
    }
  }, [formErrors]);

  const allCities = useSelector((state) => state.cities_reducer.cities)
  
  const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
};
  const permissions = JSON.parse(localStorage.getItem('permissionsList'));
  const handleGoBack = () => {
    history.goBack();
  };
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '75vh' }}>
        <CircularProgress size={60} style={{ color: '#002D72' }} />
      </div>
    );
  }
  const handletextchange = (event) => {
    const { name, value } = event.target;
    if (name === "contact1" || name === "contact2") {
      const isNumeric = /^[0-9]*$/.test(value);

      if (isNumeric) {
        setFormValues((prevValues) => ({
          ...prevValues,
          [name]: value.slice(0, 13), // Limit to 13 characters
        }));
      }
    } else {
      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };
  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'officeLocation');
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    if (editData) {
      await dispatch(updateOfficeLocation(formValues));
    } else {
      await dispatch(addOfficeLocation(formValues));
    }
    await onSave(formValues);
  };

  const handleCityChange = (event) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      cityId: event.value,
      cityName: event.label,
    }));
  };

  return (
    <>

      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container">
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={officeLocationIcon} alt="officeLocationIcon " />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Office Location" : `${t("addOfficeLocation")}`}
                </h2>
                <p className="modaldescription">
                  {t("addOfficeLocationTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <div className="dynamicmodal-form-group">
                <TextField
                  label={`${t("address")} *`}
                  type='text'
                  name="address"
                  value={formValues.address}
                  onChange={handletextchange}
                  placeholder={t("address")}
                  error={formErrors.address}
                />
              </div>

              <SingleSelect
                label={`${t("city")} *`}
                isSearchable
                secondaryLabel
                iconEnd
                error={formErrors.cityId}
                onChange={handleCityChange}
                value={formValues.cityId}
                placeholder={t("city")}
                options={getOptions("allCities")}
                configKey={"city"}
                onAddNewClick={() => handleAddNew("city")}
              />
              <div className="dynamicmodal-form-group">

                <TextField
                  name='contact1'
                  label={`${t("contact")}1 *`}
                  type='text'
                  value={formValues.contact1}
                  onChange={handletextchange}
                  placeholder={t("contact")}
                  error={formErrors.contact1}
                />
              </div>
              <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="isHeadOffice"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.isHeadOffice}
                    className="ml-1 mt-1"
                    onChange={handlecheckChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div style={{ padding: '2px' }}>
                      <BodyMediumMedium text={`${t("headOffice")} ?`} color="#1E293B" />
                    </div>
                  </label>
                </div>
              </div>

            </div>
            <div className="dynamicmodal-footer">
              <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
        </div>
      </div>

        <AddNewDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
           title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          icon={drawerItem  === "city" ? <img src={cityicon} alt={drawerItem } /> : null}
        >
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
              onClose={() => setDrawerOpen(false)}
              onSave={(newCity) => {
                if (drawerItem  === "city") {
                  dispatch(getCities(pageNumber)).then(() => {
                    setFormValues((prev) => ({
                      ...prev,
                      cityId: newCity.id,
                      cityName: newCity.name
                    }));
                  });
                }
              }}
            />

          )}
</AddNewDrawer>

    </>
  )
}

export default AddOfficeLocations


